import React from 'react';

import './AvailableEvents.styles.css';
import AvailableEventsTable from './AvailableEventsTable.container';
import {ReactComponent as EmptyIcon} from '../../assets/images/tasks/empty-icon.svg';
import useDebounce from '../../hooks/useDebounce';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { regular } from '@fortawesome/fontawesome-svg-core/import.macro';
import instance from '../../utils/axios';
import { appError, appErrorClear } from '../../redux/actions/error.action';
import { useDispatch, useSelector } from 'react-redux';
import EmptySearchResult from '../../components/empty-search-result/EmptySearchResult.component';
import { getApiUrl } from '../../utils/apiUrls';
import { apiErrorHandler } from '../../utils/errorHandler';
import ProgressBar from '../../components/progress-bar/ProgressBar.component';
import { addPad, sanitiseInput, stringPurifer } from '../../utils/helperFn';
import { openSnackBar } from '../../redux/actions/snackbar.actions';

const dataPerPage = 20;

const AvailableEventsContainer = ({ t, data, totalEvents }) => {
    const dispatch = useDispatch();
    const chkError = useSelector((state) => state.error);
    const [searchTxt, setSearchTxt] = React.useState('');

    // eslint-disable-next-line
    const [availableEvents, setAvailableEvents] = React.useState({
        data: !!data ? data : [],
        searchTerm: '',
        searchActive: false,
        isLoading: true,
        hasMore: true,
        pageNo: 0,
    });

    const searchEvents = async(searchTerm, pageNo=0) => {
        try {
            !!searchTerm && stringPurifer(searchTerm.trim())
            const token = localStorage.getItem('token');
            const events = await instance.get(`${getApiUrl('getDashboard')}?pageNo=${pageNo}&pageSize=${dataPerPage}${!!searchTerm ? `&searchTerm=${searchTerm}` : ''}`, {
                headers: {
                    "Authorization" : `Bearer ${token}`,
                }
            });

            const getData = (apiData) => {
                if(pageNo === 0 && !!events.data.candidateEventList) {
                    return { data: apiData, hasMore: !(apiData.length < dataPerPage) };
                } else if(pageNo !== 0 && !!apiData) {
                    return {data: [...new Set([...availableEvents.data, ...apiData])], hasMore: !(apiData.length < dataPerPage)}
                } else if(pageNo !== 0 && !apiData) {
                    return { data: availableEvents.data, hasMore: false };
                } else {
                    return { data: [], hasMore: false };
                }
            }

            const avEventData = getData(events.data.candidateEventList);
            
            setAvailableEvents({
                ...availableEvents,
                data: avEventData.data,
                searchTerm,
                searchActive: !!searchTerm,
                isLoading: false,
                hasMore: avEventData.hasMore,
                pageNo
            })

            if(!!events.data && chkError.location === 'home') appErrorClear(dispatch);

        } catch (error) {
            setAvailableEvents({
                ...availableEvents,
                isLoading: false,
            })
            const errObj = apiErrorHandler(error);
            if(errObj.statusText === "field_validiation_error_message_not_accepted") {
                dispatch(openSnackBar({
                    msg: t(errObj.statusText),
                    type: 'error'
                }))
                return
            }
            appError('home', error, dispatch);
        }
    }

    const handleSearch = (searchTerm) => {
        searchEvents(searchTerm, 0);
    }

    // DeBounce Function
    useDebounce(() => {
        if(searchTxt.length >= 2 || searchTxt === '') handleSearch(searchTxt)
    }, [searchTxt], 800
    );

    const handleChange = (e) => {
        setSearchTxt(sanitiseInput(e.target.value))
    }

    const resetSearchFn = () => {
        setSearchTxt('');
    }

    const nextFn = (pageNo) => {
        searchEvents(availableEvents.searchTerm, pageNo)
    }

    return(
        <div className='cm-available-events-container bg-white'>

            {
                !availableEvents.isEmpty && 
                <div className="cm-av-events-header bg-white py-3 px-4">
                    <div className="px-3 d-flex align-items-center justify-content-between">
                        <div className="d-flex align-items-center text-blue-gray-700 cm-av-events-header-title">
                            <div className="d-flex align-items-center cm-av-ev-title-col">
                                <FontAwesomeIcon icon={regular('calendar-circle-user')} className="cm-fs-14 cm-av-events-head-icon" />
                                <h4 className="h6 my-0 fw-medium ps-12 pe-2 cm-fs-14">{t("available_events")}</h4>
                            </div>
                            {!!availableEvents.data && <p className="cm-av-events-count d-flex align-items-center my-0 text-blue-gray-500 fw-medium cm-fs-14">{addPad(totalEvents)} {totalEvents > 1 ? t("events") : t("event")}</p>}
                        </div>
                        <div className="position-relative cm-av-events-search-wrap">
                            <input type="text" value={searchTxt} onChange={handleChange} className="form-control cm-sm-txt text-blue-gray-700" id="avSearch" placeholder={t("event_search_placeholder")} />
                            <FontAwesomeIcon icon={regular("search")} className="cm-search-trigger position-absolute text-gray-500" />
                        </div>
                    </div>
                </div>
            }

            {
                !availableEvents.isLoading ?
                !!data ?
                <>
                    {availableEvents.data.length > 0 ? <AvailableEventsTable pageNo={availableEvents.pageNo} searchTerm={availableEvents.searchTerm} getAvailableEvents={nextFn} hasMore={availableEvents.hasMore} availableEvents={availableEvents.data} t={t} /> : <EmptySearchResult searchTerm={availableEvents.searchTerm} resetSearchFn={resetSearchFn} />}
                </>
                :
                <div className='cm-empty-available-events-item text-center'>
                    <div className="cm-exclamation-icon-wrap position-relative mx-auto">
                        <EmptyIcon />
                    </div>
                    <p className='mb-2 text-blue-700 fw-semibold'>{t("nothing_to_see")}</p>
                    <p className='my-0 text-blue-gray-500 fw-medium cm-sm-txt'>{t("upon_invitation_event_visible_here")}</p>
                </div>
                : <ProgressBar />
            }
        </div>
    )

}

export default AvailableEventsContainer;